import { hot } from "react-hot-loader/root";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ChangeLogComponent from "./components";

import { setMenuKey } from "../../actions";
import { fetchChangeLog, fetchUsers } from './store/actions';
import changeLog from "./store/reducer";

const mapStateToProps = ({ app, changeLog }) => ({
  userInfo: app.userInfo,
  viewport: app.viewport,
  users: changeLog.users,
  changeLog: changeLog.changeLog,
  paginationInfo: changeLog.paginationInfo,

});

const mapDispatchToProps = {
  setMenuKey,
  fetchChangeLog,
  fetchUsers,
};

const ChangeLog = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(hot(ChangeLogComponent))
);

export default ChangeLog;